import App from './App.vue';
// import Empty from './Empty.vue';
import Index from './views/index.vue';
import About from './views/about.vue';
import Form from './views/form.vue';
import Price from './views/price.vue';
import OnlineRenew from './views/onlineRenew.vue';
import Pay from './views/pay.vue';
import Payment from './views/payment.vue';
import TermPersonal from './views/termPersonal.vue';
import TermCondition from './views/termCondition.vue';
import Services from './views/services.vue';
import Favorites from './views/favorites.vue';
import Signin from './views/signin.vue';
import Signup from './views/signup.vue';
import Search from './views/search.vue';
import Detail from './views/detail.vue';
import Renew from './views/renew.vue';
import Person from './views/person.vue';
import ProcessDetail from './views/processDetail.vue';
import Interviews from './views/interview.vue'; 
import NewPayment from './views/newPayment.vue'; 

const routes = [
    { path: '/', component: App,
        children: [
            {
                path: 'index',
                component: Index,
            },
            {
                path: 'about',
                component: About,
            },
            {
                path: 'form',
                component: Form,
            },
            {
                path: 'price',
                component: Price,
            },
            {
                path: 'onlinerenew',
                component: OnlineRenew,
            },
            {
                path: 'pay',
                component: Pay,
            },
            {
                path: 'person',
                component: Person,
            },
            {
                path: 'renew/:type/:orderId',
                component: Renew,
                props: true,
            },
            {
                path: 'renew/:type',
                component: Renew,
                props: true,
            },
            {
                path: 'renew',
                component: Renew,
            },
            {
                path: 'payment/:type/:orderId',
                component: Payment,
                props: true,
            },
            {
                path: 'payment/:type',
                component: Payment,
                props: true,
            },
            {
                path: 'payment',
                component: Payment,
                // props: true,
            },
            {
                path: 'services',
                component: Services,
            },
            {
                path: 'favorites',
                component: Favorites,
            },
            {
                path: 'search',
                component: Search,
            },
            {
                path: 'detail/:code',
                component: Detail,
                props: true,
            },
			{
			    path: 'processdetail/:id',
			    component: ProcessDetail,
			    props: true,
			},
			{
				path:'interviews',
				component: Interviews, 
			},
			{
			    path: 'newpayment/:orderId',
			    component: NewPayment,
			    props: true,
			},
			{
			    path: 'newpayment',
			    component: NewPayment,
			    // props: true,
			},
        ],
    },
    {
        path: '/termPersonal',
        component: TermPersonal,
    },
    {
        path: '/termCondition',
        component: TermCondition,
    },
    {
        path: '/signin',
        component: Signin,
    },
    {
        path: '/signup',
        component: Signup,
    },
];

export default routes;
